import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 15 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="animate-slide-down bg-[#eef7f1] text-[#2a5a3a] py-1.5 px-4 text-center sticky top-0 z-50 shadow-sm border-b border-[#c8e8d0]" data-id="element-360">
      <div className="inline-flex items-center gap-2 md:gap-3" data-id="element-361">
        <span className="text-[#2a5a3a]/60 text-xs tracking-[0.15em] uppercase" style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontWeight: 600
      }} data-id="element-362">
          Oferta expira en
        </span>
        <span className="bg-[#2a5a3a] text-[#b8f0c8] px-2.5 py-0.5 rounded text-sm tracking-widest leading-tight" style={{
        fontFamily: "'Bebas Neue', sans-serif",
        letterSpacing: '0.18em'
      }} data-id="element-363">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
        <span className="text-[#2a5a3a]/30 text-xs" data-id="element-364">·</span>
        <span className="text-[#2a5a3a]/70 text-xs tracking-[0.12em] uppercase" style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontWeight: 600
      }} data-id="element-365">
          🔥 Cupos limitados
        </span>
      </div>
    </div>;
}